export const videoButtonSizes = {
    small: [3.5, 1.25],
    medium: [4.5, 1.625],
    large: [6, 2],
    xlarge: [8, 2.5],
};
